export default {
  REGENOFF: 'ReGen Off',
  REGENON: 'ReGen On',
  FUELON: 'Fuel On',
  // FUELOFF: 'Fuel Off',
  IGNITIONON: 'Ignition On',
  IGNITIONOFF: 'Ignition Off',
  TIMEDUPDATE: 'Timed Update',
};
